import styled from 'styled-components';

export const Container = styled.div.attrs({
  className: 'content'
})``;

export const ModalContainer = styled(Container)`
  justify-content: space-between;
  align-items: center;
  button {
    width: 100%;
  }
`;
